<script>
export default {
    functional: true,

    render: function(createElement, context){
        return createElement("ul",
            context.props.messages.map(e => {
                return createElement("li", [
                    createElement("strong", e)
                ]);
            })
        );
    }
};
</script>
